import React from 'react';
import { Spinner } from 'react-bootstrap';

interface Props {
    isLoading: boolean;
    children: React.ReactElement;
    isData: boolean; // condition that children have list from API
    isSmall?: boolean;
}

const DataListHandler:React.FC<Props> = (props) => {
  const {
    isLoading, children, isData, isSmall,
  } = props;
  if (isLoading) {
    return (
      <div className="w-100 flexible-center">
        <Spinner animation="border" size={isSmall ? 'sm' : undefined} />
      </div>
    );
  }
  if (isData) {
    return children;
  }
  return <div className={`text-center w-100 ${isSmall ? 'fz-14' : ''}`}>Data Not Found</div>;
};

export default React.memo(DataListHandler);
